var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Woonggi Kim
 * @contact wgkim@detech.co.kr
 * @date 2024-03-25
 * @brief SEI 공지사항 관리 개발
 *
 ********************************************************************/
import { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
// recoil
import { alertState, confirmState } from "../../../recoil/assessmentState";
import { userInfoLoginState } from "../../../recoil/userState";
// utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import Editor from "ckeditor5-custom-build";
import { API_BASE } from "../../../utils/api/HttpConf";
//component
import dayjs from "dayjs";
import { loadingBoxState } from "../../../recoil/menuState";
import EhpPagination from "../../common/pagination/EhpPagination";
import CmmConfirmPop from "../../common/popup/CmmConfirmPop";
export default function InformMain() {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [informList, setInformList] = useState([{}]);
    const [stateName, setStateName] = useState("전체");
    const [state, setState] = useState("");
    const [langName, setLangName] = useState("전체");
    const [lang, setLang] = useState("");
    const [reload, setReload] = useState(0);
    const [informId, setInformId] = useState(0);
    const [delInformId, setDelInformId] = useState(0);
    // props
    const { handleOpenPop } = useOutletContext();
    useEffect(() => {
        handleOpenPop("pop-cmm", _jsx(AddInform, { setReload: setReload, informId: informId, setInformId: setInformId }));
        handleOpenPop("pop-cmm2", _jsx(DeleteInform, { setReload: setReload, informId: delInformId, setDelInformId: setDelInformId }));
    }, [informId, delInformId]);
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    const [sortData, setSortData] = useState({
        sortField: "updatedTime",
        sort: "desc",
    });
    let page = `page=${pageInfo.number}&size=${pageInfo.size}&sort=${sortData.sortField},${sortData.sort}`;
    let param = ``;
    if (lang != "") {
        param = "";
        param = param + `&langId=${lang}`;
    }
    else {
        param = "";
    }
    if (state != "") {
        param = param + `&isPublic=${state}`;
    }
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/informs?${page}${param}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: page + param + reload,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                let trs = document.querySelector("#listBody").children;
                Array.prototype.forEach.call(trs, (element) => element.classList.remove("selected"));
                setInformList(data.body);
                setPageInfo(data.data.page);
            }
        }
    }, [data]);
    function onClickSelect(e) {
        let select = e.currentTarget;
        if (select.classList.contains("active")) {
            select.classList.remove("active");
        }
        else {
            select.classList.add("active");
        }
    }
    function selectTr(e, index) {
        let target = e.currentTarget;
        // let isBanned = reportList[index].isBanned;
        if (target.classList.contains("selected")) {
            target.classList.remove("selected");
            // if(!isBanned) target.childNodes[7].childNodes[0].childNodes[0].innerText = "공개";
        }
        else {
            let trs = document.querySelector("#listBody").children;
            Array.prototype.forEach.call(trs, (element) => element.classList.remove("selected"));
            target.classList.add("selected");
            // if(!isBanned) target.childNodes[7].childNodes[0].childNodes[0].innerText = "변경";
        }
    }
    function onSelectBox(e, type) {
        let selType = e.currentTarget.dataset.value;
        let li = e.currentTarget;
        let lis = li.parentNode.childNodes;
        lis.forEach((item, index) => (item.className = "option"));
        li.className = "option active";
        if (type == "isPublic") {
            setStateName(e.currentTarget.innerText);
            setState(selType);
            setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: 0 }));
        }
        else {
            setLangName(e.currentTarget.innerText);
            setLang(selType);
            setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: 0 }));
        }
    }
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    function openAddInform(e, id) {
        if (id == null) {
            CUTIL.jsopen_Popup(e);
        }
        else {
            setInformId(id);
            CUTIL.jsopen_Popup(e);
        }
    }
    function openDeleteInform(e, id) {
        setDelInformId(id);
        CUTIL.jsopen_Popup(e);
    }
    function onClickSort(e) {
        var actTag = e.target.tagName == "TH" ? e.target : e.currentTarget;
        var selSortField = actTag.getAttribute("data-value");
        var selSort = sortData.sort === "asc" ? "DESC" : "asc";
        if (selSortField !== sortData.sortField) {
            // 정렬필드가 변경된 경우
            selSort = "DESC";
        }
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: 0 }));
        setSortData({
            sortField: selSortField,
            sort: selSort,
        });
    }
    return (_jsx("div", Object.assign({ className: "box-wrap" }, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: "\uACF5\uC9C0\uC0AC\uD56D \uAD00\uB9AC" })) })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsx("span", Object.assign({ className: "mr-24" }, { children: _jsx("strong", { children: "\uC0C1\uD0DC" }) })), _jsxs("div", Object.assign({ className: "select w158", onClick: (e) => onClickSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: stateName })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "isPublic"), "data-value": "" }, { children: "\uC804\uCCB4" })), _jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "isPublic"), "data-value": "true" }, { children: "\uACF5\uAC1C" })), _jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "isPublic"), "data-value": "false" }, { children: "\uBE44\uACF5\uAC1C" }))] })] })), _jsx("span", Object.assign({ className: "mr-16 ml-48" }, { children: _jsx("strong", { children: "\uC5B8\uC5B4" }) })), _jsxs("div", Object.assign({ className: "select w158", onClick: (e) => onClickSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: langName })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "langId"), "data-value": "" }, { children: "\uC804\uCCB4" })), _jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "langId"), "data-value": "1" }, { children: "\uD55C\uAD6D\uC5B4" })), _jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "langId"), "data-value": "2" }, { children: "\uC601\uC5B4" }))] })] }))] })) })) })), _jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic js-open", "data-pop": "pop-cmm", onClick: (e) => openAddInform(e, null) }, { children: _jsx("span", { children: "\uACF5\uC9C0\uD31D\uC5C5 \uCD94\uAC00" }) })) }))] })), _jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "No., \uB178\uCD9C\uC704\uCE58, \uC0C1\uD0DC, \uC81C\uBAA9, \uACF5\uC9C0\uD31D\uC5C5\uB0B4\uC6A9, \uB4F1\uB85D\uC77C\uC790, \uC218\uC815, \uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uACF5\uC9C0\uC0AC\uD56D \uAD00\uB9AC \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uACF5\uC9C0\uC0AC\uD56D \uAD00\uB9AC \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "19%" } }), _jsx("col", { style: { width: "37%" } }), _jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "6%" } }), _jsx("col", { style: { width: "6%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "No." }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uB178\uCD9C \uC704\uCE58" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "isPublic" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "isPublic" }, { children: _jsx("span", { children: "\uC0C1\uD0DC" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uC81C\uBAA9" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uACF5\uC9C0\uD31D\uC5C5 \uB0B4\uC6A9" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "updatedTime" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "updatedTime" }, { children: _jsx("span", { children: "\uB4F1\uB85D \uC77C\uC790" }) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: _jsx("span", { children: "\uC218\uC815" }) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: _jsx("span", { children: "\uC0AD\uC81C" }) }))] }) }), _jsx("tbody", Object.assign({ id: "listBody" }, { children: informList &&
                                            informList.map((item, index) => (_jsxs("tr", Object.assign({ onClick: (e) => selectTr(e, index) }, { children: [_jsx("td", { children: pageInfo.totalElements - pageInfo.number * pageInfo.size - index }), _jsx("td", { children: item.location == 1 ? "대시보드" : item.location == 2 ? "소개" : "소개/대시보드" }), _jsx("td", { children: _jsx("span", Object.assign({ className: item.isPublic ? "txt-blue" : "txt-gray" }, { children: item.isPublic ? "공개" : "비공개" })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis w90p" }, { children: item.title })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis w90p" }, { children: item.contentText })) }), _jsx("td", { children: dayjs(item.updatedTime).format("YYYY-MM-DD") }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g", "data-pop": "pop-cmm", onClick: (e) => openAddInform(e, item.informId) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })) }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-cmm2", onClick: (e) => openDeleteInform(e, item.informId) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }), `inform_${index}`))) }))] })) })), _jsx(EhpPagination, { componentName: "INFORM", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))] })) })));
}
function AddInform(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [confirm, setConfirm] = useRecoilState(confirmState);
    const loadingBox = useSetRecoilState(loadingBoxState);
    const idsRef = useRef(null);
    const urlsRef = useRef(null);
    const [location, setLocation] = useState(0); // 1: 대시보드, 2: 소개, 3: 둘다
    const [title, setTitle] = useState("");
    const [position, setPosition] = useState(1);
    const [isViewOneDay, setIsViewOneDay] = useState(false);
    const [link, setLink] = useState("");
    const [isPublic, setIsPublic] = useState(true);
    const [langId, setLangId] = useState(1); // 1: kor, 2: eng
    const [content, setContent] = useState("");
    const [fileList, setFileList] = useState([]);
    const [fileCnt, setFileCnt] = useState(0);
    const [disabledBtn, setDisabledBtn] = useState(false);
    let informId = props.informId;
    useEffect(() => {
        if (informId != 0) {
            callDetailInform(informId);
        }
    }, [informId]);
    const customUploadAdapter = (loader) => {
        return {
            upload() {
                return new Promise((resolve, reject) => {
                    const data = new FormData();
                    loader.file.then((file) => {
                        data.append("files", file);
                        axios
                            .post(API_BASE + "/file/inform/editor", data, {
                            headers: { Authorization: userInfo.loginInfo.token },
                        })
                            .then((res) => {
                            if (res) {
                                if (res.status == CONST.API_200) {
                                    let image = res.data.list[0];
                                    let ids = idsRef.current.value;
                                    ids = ids == "" ? image.fileId : ids + "," + image.fileId;
                                    idsRef.current.value = ids;
                                    let urls = urlsRef.current.value;
                                    urls = urls == "" ? image.url : urls + "," + image.url;
                                    urlsRef.current.value = urls;
                                    resolve({
                                        default: res.data.list[0].url,
                                    });
                                }
                            }
                        })
                            .catch((err) => reject(err));
                    });
                });
            },
        };
    };
    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return customUploadAdapter(loader);
        };
    }
    const editorOption = {
        toolbar: {
            items: [
                "undo",
                "redo",
                "|",
                "heading",
                "|",
                "bold",
                "italic",
                "underline",
                "|",
                "outdent",
                "indent",
                "alignment",
                "|",
                "bulletedList",
                "numberedList",
                "|",
                "link",
                "|",
                "imageInsert",
                "mediaEmbed",
            ],
        },
        image: {
            toolbar: [
                "imageTextAlternative",
                "toggleImageCaption",
                "imageStyle:inline",
                "imageStyle:block",
                "imageStyle:side",
                "linkImage",
            ],
        },
        link: {
            addTargetToExternalLinks: true,
        },
        extraPlugins: [uploadPlugin],
    };
    function closePop() {
        CUTIL.jsclose_Popup("pop-cmm");
        props.setInformId(0);
        setDisabledBtn(false);
        setInit();
    }
    function setInit() {
        setLocation(0); // 1: 대시보드, 2: 소개, 3: 둘다
        setTitle("");
        setPosition(1);
        setIsViewOneDay(false);
        setLink("");
        setIsPublic(true);
        setLangId(1); // 1: kor, 2: eng
        setContent("");
        setFileList([]);
        setFileCnt(0);
        idsRef.current.value = "";
        urlsRef.current.value = "";
        let locations = document.getElementsByName("location");
        Array.prototype.forEach.call(locations, (element) => {
            element.checked = false;
        });
        let positions = document.getElementsByName("position");
        Array.prototype.forEach.call(positions, (element) => {
            if (element.id == "position_center") {
                element.checked = true;
            }
            else {
                element.checked = false;
            }
        });
        let isPublics = document.getElementsByName("isPublic");
        Array.prototype.forEach.call(isPublics, (element) => {
            if (element.id == "isPublic_true") {
                element.checked = true;
            }
            else {
                element.checked = false;
            }
        });
        let langIds = document.getElementsByName("langId");
        Array.prototype.forEach.call(langIds, (element) => {
            if (element.id == "langId_kor") {
                element.checked = true;
            }
            else {
                element.checked = false;
            }
        });
    }
    function handleLocation(e) {
        let locations = document.getElementsByName("location");
        let list = [];
        Array.prototype.forEach.call(locations, (element) => {
            if (element.checked) {
                list.push(element.id);
            }
            else if (!element.checked && list.indexOf(element.id) > 0) {
                list.splice(list.indexOf(element.id), 1);
            }
        });
        if (list.includes("landing") && list.includes("dashboard"))
            setLocation(3);
        else if (list.includes("landing"))
            setLocation(2);
        else if (list.includes("dashboard"))
            setLocation(1);
        else
            setLocation(0);
    }
    function handleTitle(e) {
        setTitle(e.target.value);
    }
    function handlePosition(e) {
        setPosition(e.target.value);
    }
    function handleViewOneDay(e) {
        if (e.target.checked)
            setIsViewOneDay(true);
        else
            setIsViewOneDay(false);
    }
    function handleLink(e) {
        setLink(e.target.value);
    }
    function handleIsPublic(e) {
        setIsPublic(e.target.value);
    }
    function handleLang(e) {
        setLangId(e.target.value);
    }
    function saveInform() {
        let cntnt = "공지를 추가하시겠습니까?";
        let hedrt = "공지팝업";
        let method = "POST";
        let url = `/inform`;
        if (informId != 0) {
            cntnt = "공지를 수정하시겠습니까?";
            method = "PUT";
            url = url + `/${informId}`;
        }
        if (location == 0) {
            setDisabledBtn(true);
            setAlert(Object.assign(Object.assign({}, alert), { header: "공지팝업", type: CONST.TYPE_NONE, divTag: "공지팝업 노출위치를 선택해주세요.", callBack: (e) => {
                    setDisabledBtn(false);
                } }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            return;
        }
        else if (content == "" || content == "<p>&nbsp;</p>") {
            setDisabledBtn(true);
            setAlert(Object.assign(Object.assign({}, alert), { header: "공지팝업", type: CONST.TYPE_NONE, divTag: "공지팝업 내용을 입력해주세요.", callBack: (e) => {
                    setDisabledBtn(false);
                } }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            return;
        }
        setConfirm(Object.assign(Object.assign({}, confirm), { header: hedrt, content: cntnt, leftBtnName: "취소", rightBtnName: "확인", leftBtnCallBack: (e) => {
                setDisabledBtn(false);
            }, rightBtnCallBack: (e) => __awaiter(this, void 0, void 0, function* () {
                loadingBox(true);
                let res = yield HTTPUTIL.PromiseHttp({
                    httpMethod: method,
                    appPath: url,
                    appQuery: {
                        location: location,
                        title: title,
                        position: position,
                        isViewOneDay: isViewOneDay,
                        isPublic: isPublic,
                        link: link,
                        langId: langId,
                        content: content,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (res) {
                    if (res.codeNum == CONST.API_200) {
                        updateEditorImage(res.body.informId);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { header: "공지팝업", type: CONST.TYPE_NONE, divTag: "추가 실패하였습니다." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }) }));
        setDisabledBtn(true);
        CUTIL.jsopen_AlertPopup(CONST.POP_CMM_CONFIRM);
    }
    function updateEditorImage(id) {
        let cntet = content;
        let ids = [];
        let idList = idsRef.current.value.split(",");
        let urlList = urlsRef.current.value.split(",");
        urlList.forEach((item, index) => {
            if (cntet.indexOf(item) > 0) {
                ids.push(idList[index]);
            }
            if (urlList.length == index + 1) {
                HTTPUTIL.jsonFetch(`/file/inform/${id}`, "PUT", userInfo.loginInfo.token, { fileIds: ids }, (e) => {
                    fileUpload(id);
                });
            }
        });
        if (urlList.length == 0) {
            fileUpload(id);
        }
    }
    function onChangeFile(e) {
        let val = e.target.files;
        let files = CUTIL.isnull(fileList) ? [] : [...fileList];
        let originLength = fileList.length;
        Array.prototype.forEach.call(val, function (item) {
            if (item.size >= 524288000) {
                setAlert(Object.assign(Object.assign({}, alert), { header: "파일 첨부", type: CONST.TYPE_NONE, divTag: "파일 하나당 최대 500MB까지 첨부가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                return;
            }
            files.push(item);
        });
        if (originLength + val.length > 10) {
            setAlert(Object.assign(Object.assign({}, alert), { header: "파일 첨부", type: CONST.TYPE_NONE, divTag: "파일은 최대 10개까지 첨부가능합니다." }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
        else {
            setFileList(files);
            setFileCnt(fileCnt + val.length);
        }
    }
    function fileUpload(id) {
        return __awaiter(this, void 0, void 0, function* () {
            let cntnt = "공지 등록이 완료되었습니다.";
            if (informId != 0)
                cntnt = "공지 수정이 완료되었습니다.";
            let cnt = 0;
            if (fileCnt > 0) {
                let appPath = `?informId=${id}`;
                // 파일 데이터 저장
                fileList.map((file) => __awaiter(this, void 0, void 0, function* () {
                    if (file.fileId == null) {
                        const formData = new FormData();
                        formData.append("files", file);
                        let data = null;
                        data = yield HTTPUTIL.PromiseHttp({
                            httpMethod: "POSTF",
                            appPath: `/file/inform/attach${appPath}`,
                            appQuery: formData,
                            userToken: userInfo.loginInfo.token,
                        });
                        if (data) {
                            if (data.codeNum == CONST.API_200) {
                                cnt = cnt + 1;
                                if (cnt == fileCnt) {
                                    loadingBox(false);
                                    setAlert(Object.assign(Object.assign({}, alert), { header: "공지 팝업", type: CONST.TYPE_NONE, divTag: cntnt, callBack: (e) => {
                                            closePop();
                                            props.setReload(Math.floor(Math.random() * 8999999) + 1000000);
                                        } }));
                                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                                }
                            }
                            else {
                                loadingBox(false);
                                setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: "파일 업로드 오류" }));
                                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                            }
                        }
                    }
                }));
            }
            else {
                loadingBox(false);
                setAlert(Object.assign(Object.assign({}, alert), { header: "공지 팝업", type: CONST.TYPE_NONE, divTag: cntnt, callBack: (e) => {
                        closePop();
                        props.setReload(Math.floor(Math.random() * 8999999) + 1000000);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
        });
    }
    function callDetailInform(id) {
        return __awaiter(this, void 0, void 0, function* () {
            loadingBox(true);
            let data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/inform/${id}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    loadingBox(false);
                    let body = data.body;
                    setDetail(body);
                }
                else {
                    loadingBox(false);
                    setAlert(Object.assign(Object.assign({}, alert), { header: "공지사항 수정", type: CONST.TYPE_NONE, divTag: "상세 불러오기 오류" }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function setDetail(item) {
        setFileList(item.attachFiles);
        setContent(item.content == null ? "" : item.content);
        setIsPublic(item.isPublic);
        setIsViewOneDay(item.isViewOneDay);
        setLangId(item.language == "Korean" ? 1 : 2);
        setLink(item.link == null ? "" : item.link);
        setLocation(item.location);
        setTitle(item.title == null ? "" : item.title);
        setPosition(item.position);
        let ids = [];
        let urls = [];
        item.editorFiles.map((item) => {
            ids.push(item.fileId);
            urls.push(item.url);
        });
        idsRef.current.value = ids.toString();
        urlsRef.current.value = urls.toString();
        let locations = document.getElementsByName("location");
        Array.prototype.forEach.call(locations, (element) => {
            if ((item.location == 1 || item.location == 3) && element.id == "dashboard") {
                element.checked = true;
            }
            else if ((item.location == 2 || item.location == 3) && element.id == "landing") {
                element.checked = true;
            }
        });
        let positions = document.getElementsByName("position");
        Array.prototype.forEach.call(positions, (element) => {
            if (element.id == "position_center" && item.position == 1) {
                element.checked = true;
            }
            else if (element.id == "position_left" && item.position == 2) {
                element.checked = true;
            }
        });
        let isPublics = document.getElementsByName("isPublic");
        Array.prototype.forEach.call(isPublics, (element) => {
            if (element.id == "isPublic_true" && item.isPublic == true) {
                element.checked = true;
            }
            else if (element.id == "isPublic_false" && item.isPublic == false) {
                element.checked = true;
            }
        });
        let langIds = document.getElementsByName("langId");
        Array.prototype.forEach.call(langIds, (element) => {
            if (element.id == "langId_kor" && item.language == "Korean") {
                element.checked = true;
            }
            else if (element.id == "langId_eng" && item.language == "English") {
                element.checked = true;
            }
        });
    }
    function deleteFile(index) {
        let files = [...fileList];
        let cnt = fileCnt;
        if (CUTIL.isnull(files[index].fileId)) {
            files.splice(index, 1);
            setFileList(() => []);
            setFileList([...files]);
            setFileCnt(cnt - 1);
        }
        else {
            setConfirm(Object.assign(Object.assign({}, confirm), { header: "파일", content: "파일을 삭제하시겠습니까?", leftBtnName: "취소", rightBtnName: "삭제", rightBtnCallBack: () => __awaiter(this, void 0, void 0, function* () {
                    let fileId = files[index].fileId;
                    let resDelete = null;
                    resDelete = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "DELETE",
                        appPath: `/file/${fileId}`,
                        appQuery: {},
                        userToken: userInfo.loginInfo.token,
                    });
                    if (resDelete) {
                        if (resDelete.codeNum == CONST.API_200) {
                            files.splice(index, 1);
                            setFileList(() => []);
                            setFileList([...files]);
                        }
                    }
                }) }));
            CUTIL.jsopen_AlertPopup(CONST.POP_CMM_CONFIRM);
        }
    }
    function downloadFile(url) {
        let a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("download", "");
        document.body.append(a);
        a.click();
        a.remove();
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ id: "pop-cmm", className: "popup-layer js-layer hidden popup-type2 w1080" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "\uACF5\uC9C0\uD31D\uC5C5 \uCD94\uAC00" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: closePop, disabled: disabledBtn }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "flex-row m-mt-16" }, { children: [_jsxs("div", Object.assign({ className: "pop-left flex-1 pb-12" }, { children: [_jsx("ul", Object.assign({ className: "form__input mt-5" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uB178\uCD9C \uC704\uCE58" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("ul", Object.assign({ className: "checkBox size-16 mt-5 mb-5" }, { children: [_jsxs("li", { children: [_jsx("input", { type: "checkbox", id: "landing", name: "location", onClick: handleLocation }), _jsx("label", Object.assign({ htmlFor: "landing", className: "pl-24" }, { children: "SEI \uB79C\uB529\uD398\uC774\uC9C0" }))] }), _jsxs("li", Object.assign({ className: "ml-20" }, { children: [_jsx("input", { type: "checkbox", id: "dashboard", name: "location", onClick: handleLocation }), _jsx("label", Object.assign({ htmlFor: "dashboard", className: "pl-24" }, { children: "Beyond X\u2122 Enable \uB300\uC2DC\uBCF4\uB4DC" }))] }))] })) }))] }) })), _jsxs("ul", Object.assign({ className: "form__input brd-top-1 pt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC81C\uBAA9" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "title", value: title, placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", onChange: (e) => handleTitle(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uD31D\uC5C5 \uC704\uCE58" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "position_center" }, { children: [_jsx("input", { type: "radio", id: "position_center", name: "position", value: "1", onClick: (e) => handlePosition(e), defaultChecked: true }), "\uAC00\uC6B4\uB370 \uC815\uB82C"] })), _jsxs("label", Object.assign({ htmlFor: "position_left" }, { children: [_jsx("input", { type: "radio", id: "position_left", name: "position", value: "2", onClick: (e) => handlePosition(e) }), "\uD654\uBA74 \uC704, \uC67C\uCABD\uBD80\uD130 100px"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB178\uCD9C \uC635\uC158" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("ul", Object.assign({ className: "checkBox size-16 mt-5" }, { children: _jsxs("li", { children: [_jsx("input", { type: "checkbox", id: "isViewOneDay", checked: isViewOneDay, onChange: (e) => handleViewOneDay(e) }), _jsx("label", Object.assign({ htmlFor: "isViewOneDay", className: "pl-24" }, { children: "\uC624\uB298\uD558\uB8E8 \uBCF4\uC9C0 \uC54A\uAE30" }))] }) })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB9C1\uD06C \uC635\uC158" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", value: link, placeholder: "ex)www.ls-electric.com", className: "txt-blue", onChange: (e) => handleLink(e) }), _jsx("p", Object.assign({ className: "txt-info" }, { children: "User\uAC00 \uACF5\uC9C0\uD31D\uC5C5 \uB0B4\uC6A9\uC744 \uD074\uB9AD \uC2DC \uC774\uB3D9\uD558\uAC8C\uB418\uB294 \uB9C1\uD06C\uB97C \uC124\uC815\uD574\uC8FC\uC138\uC694." }))] }))] })] })), _jsxs("ul", Object.assign({ className: "form__input brd-top-1 pt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC0C1\uD0DC \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "isPublic_true" }, { children: [_jsx("input", { type: "radio", id: "isPublic_true", name: "isPublic", value: "true", onClick: (e) => handleIsPublic(e), defaultChecked: true }), "\uACF5\uAC1C"] })), _jsxs("label", Object.assign({ htmlFor: "isPublic_false" }, { children: [_jsx("input", { type: "radio", id: "isPublic_false", name: "isPublic", value: "false", onClick: handleIsPublic }), "\uBE44\uACF5\uAC1C"] }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC5B8\uC5B4 \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "langId_kor" }, { children: [_jsx("input", { type: "radio", id: "langId_kor", name: "langId", value: "1", onClick: (e) => handleLang(e), defaultChecked: true }), "\uD55C\uAD6D\uC5B4"] })), _jsxs("label", Object.assign({ htmlFor: "langId_eng" }, { children: [_jsx("input", { type: "radio", id: "langId_eng", name: "langId", value: "2", onClick: (e) => handleLang(e) }), "\uC601\uC5B4"] }))] })) }))] })] }))] })), _jsxs("div", Object.assign({ className: "pop-right flex-1-2-7 pb-12 wmax-512" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("h2", Object.assign({ className: "star" }, { children: "\uACF5\uC9C0\uD31D\uC5C5 \uB0B4\uC6A9" })) })), _jsxs("ul", Object.assign({ className: "form__input brd-top-1 pt-24" }, { children: [_jsx("li", { children: _jsx("div", Object.assign({ className: "editbox-wrap " }, { children: _jsx(CKEditor, { editor: Editor, data: content, config: editorOption, onChange: (event, editor) => {
                                                                setContent(editor.getData()); // 에디터 작성 내용 저장
                                                            } }) })) }), _jsx("li", { children: _jsxs("div", { children: [_jsx("p", Object.assign({ className: "tit mt-0" }, { children: _jsx("strong", { children: "\uCCA8\uBD80\uD30C\uC77C" }) })), _jsxs("div", Object.assign({ className: "input__area mt-10" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", placeholder: "\uD30C\uC77C\uC744 \uCCA8\uBD80\uD558\uC138\uC694" }), _jsx("label", Object.assign({ htmlFor: "file" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file", multiple: true, onChange: (e) => onChangeFile(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: "500MB\uC774\uD558\uC758 JPG, PNG, \uB3D9\uC601\uC0C1 \uD30C\uC77C 10\uAC1C\uAE4C\uC9C0 \uC5C5\uB85C\uB4DC \uAC00\uB2A5\uD569\uB2C8\uB2E4." })), _jsx("div", Object.assign({ className: "h80 scrollH" }, { children: _jsx("ul", Object.assign({ className: "filelist mt-12" }, { children: fileList &&
                                                                                fileList.map((item, index) => (_jsxs("li", { children: [_jsx("span", Object.assign({ onClick: () => downloadFile(item.url), style: { cursor: "pointer" } }, { children: item.name })), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: () => deleteFile(index) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, `fileList_${index}`))) })) }))] }))] }) })] }))] }))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", disabled: disabledBtn, className: "bg-gray js-close", onClick: closePop }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", disabled: disabledBtn, onClick: saveInform }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))] }))] })), _jsx("input", { type: "hidden", ref: idsRef }), _jsx("input", { type: "hidden", ref: urlsRef }), _jsx(CmmConfirmPop, {})] }));
}
function DeleteInform(props) {
    // 화면 이동
    const navigate = useNavigate();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    function closePop() {
        props.setDelInformId(0);
        CUTIL.jsclose_Popup("pop-cmm2");
    }
    function deleteInform() {
        return __awaiter(this, void 0, void 0, function* () {
            let resDelete = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/inform/${props.informId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (resDelete) {
                if (resDelete.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { header: "공지 팝업", type: CONST.TYPE_NONE, divTag: "삭제가 완료되었습니다.", callBack: (e) => {
                            closePop();
                            props.setReload(Math.floor(Math.random() * 8999999) + 1000000);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-cmm2", className: "popup-layer js-layer hidden popup-basic" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "\uC0AD\uC81C" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: closePop }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uB4F1\uB85D\uB41C \uACF5\uC9C0\uD31D\uC5C5\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: closePop }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: deleteInform }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] })) }));
}
